module.exports = "/virtual-football-league/img/video/clubs/spain/valencia.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/spain/valencia.png
// module id = 357
// module chunks = 4